import React,  { useEffect } from 'react';
import Router from './Components/Router';
import NavigatorPage from './Components/Navigator';
import FooterPage from './Components/Footer';
import {BrowserRouter} from 'react-router-dom';

function App() {


  return (
   
    <>       
      <NavigatorPage/>       
      <Router/>                 
      <FooterPage/>
    </>
    
  );
 
}

export default App;


